import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import styled from 'styled-components';

const Input = styled.input`
  opacity: 0;
  position: absolute;
  z-index: -1;
  pointer-events: none;
  appearance: none;
  caret-color: transparent;
  outline: 0;
  border: 0;
`;

class EmbedScanner extends React.PureComponent {
  static propTypes = {
    onDetect: PropTypes.func,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    onDetect: _.identity,
    disabled: false,
  };

  onReFocus = () => {
    if (this.props.disabled) return;

    this.input.focus();
  };

  onChange = ({ target: { value } }) => {
    this.onDetect(value);
  };

  onDetect = _.debounce(value => {
    this.input.value = '';

    if (_.size(value) <= 3) return;

    this.props.onDetect(value);
  }, 150);

  ref = el => (this.input = el);

  render() {
    return (
      <Input
        autoFocus
        innerRef={this.ref}
        onChange={this.onChange}
        onBlur={this.onReFocus}
      />
    );
  }
}

export default EmbedScanner;



// WEBPACK FOOTER //
// ../pos-master/packages/pos-components/src/EmbedScanner/EmbedScanner.jsx